(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["danfee-duty-estimator-collapsible"] && !Shopify.designMode) return;
  try {
    (() => {
    const rates = {
      AT: { duty: 0.025, tax: 0.20 }, AU: { duty: 0.05, tax: 0.10 },
      BE: { duty: 0.025, tax: 0.21 }, CA: { duty: 0.065, tax: 0.05 },
      CH: { duty: 0, tax: 0.081 }, DE: { duty: 0.025, tax: 0.19 },
      DK: { duty: 0.025, tax: 0.25 }, ES: { duty: 0.025, tax: 0.21 },
      FI: { duty: 0.025, tax: 0.255 }, FR: { duty: 0.025, tax: 0.20 },
      GB: { duty: 0.025, tax: 0.20 }, HK: { duty: 0, tax: 0 },
      IE: { duty: 0.025, tax: 0.23 }, IT: { duty: 0.025, tax: 0.22 },
      JP: { duty: 0.052, tax: 0.10 }, KR: { duty: 0.08, tax: 0.10 },
      LU: { duty: 0.025, tax: 0.17 }, NL: { duty: 0.025, tax: 0.21 },
      NO: { duty: 0, tax: 0.25 }, NZ: { duty: 0.05, tax: 0.15 },
      PL: { duty: 0.025, tax: 0.23 }, PT: { duty: 0.025, tax: 0.23 },
      SE: { duty: 0.025, tax: 0.25 }, SG: { duty: 0, tax: 0.09 },
      TW: { duty: 0.05, tax: 0.05 }, AE: { duty: 0.05, tax: 0.05 },
      US: { duty: null, tax: null }
    };

    const formatPercent = (value) => new Intl.NumberFormat(document.documentElement.lang || 'en', {
      style: 'percent',
      maximumFractionDigits: 1
    }).format(value);

    const initialize = (root) => {
      if (root.dataset.dutyInitialized === 'true') return;
      root.dataset.dutyInitialized = 'true';

      const select = root.querySelector('[data-duty-country]');
      const selection = root.querySelector('[data-duty-selection]');
      const goods = root.querySelector('[data-duty-goods]');
      const dutyOutput = root.querySelector('[data-duty-duty]');
      const taxOutput = root.querySelector('[data-duty-tax]');
      const totalOutput = root.querySelector('[data-duty-total]');
      const rateOutput = root.querySelector('[data-duty-rate]');
      const unsupported = root.querySelector('[data-duty-unsupported]');
      const localizationForm = root.querySelector('.danfee-duty-row__localization-form');
      const countryInput = root.querySelector('[data-duty-country-input]');
      const variantData = root.querySelector('[data-duty-variants]');
      const variants = variantData ? JSON.parse(variantData.textContent) : [];
      const currency = root.dataset.currency || 'USD';
      const labels = {
        selected: root.dataset.labelSelected,
        rate: root.dataset.labelRate,
        tax: root.dataset.labelTax,
        unavailable: root.dataset.labelUnavailable
      };
      const formatter = new Intl.NumberFormat(document.documentElement.lang || 'en', {
        style: 'currency',
        currency
      });

      const getAmount = () => {
        const selectedOptions = Array.from(document.querySelectorAll('select[data-option-name], input[data-option-name]:checked'))
          .map((input) => input.value);
        const optionVariant = selectedOptions.length
          ? variants.find((variant) => selectedOptions.every((value, index) => variant.options[index] === value))
          : null;
        if (optionVariant) return Number(optionVariant.price) / 100;
        const formVariant = document.querySelector('form[action*="/cart/add"] [name="id"]');
        const currentId = formVariant ? String(formVariant.value) : '';
        const currentVariant = variants.find((variant) => String(variant.id) === currentId);
        return Number(currentVariant ? currentVariant.price : root.dataset.amount || 0) / 100;
      };

      const render = () => {
        const code = select.value;
        const countryName = select.options[select.selectedIndex]?.textContent.trim() || code;
        const amount = getAmount();
        const rate = rates[code];

        selection.textContent = `${labels.selected}: ${countryName}`;
        goods.textContent = formatter.format(amount);

        if (!rate || rate.duty === null || rate.tax === null) {
          dutyOutput.textContent = labels.unavailable;
          taxOutput.textContent = labels.unavailable;
          totalOutput.textContent = formatter.format(amount);
          rateOutput.textContent = '';
          unsupported.hidden = false;
          return;
        }

        const duty = amount * rate.duty;
        const tax = (amount + duty) * rate.tax;
        const total = amount + duty + tax;
        dutyOutput.textContent = formatter.format(duty);
        taxOutput.textContent = formatter.format(tax);
        totalOutput.textContent = formatter.format(total);
        rateOutput.textContent = `${labels.rate} ${formatPercent(rate.duty)} · ${labels.tax} ${formatPercent(rate.tax)}`;
        unsupported.hidden = true;
      };

      const transitionRender = () => {
        if (document.startViewTransition) document.startViewTransition(render);
        else render();
      };

      select.addEventListener('change', () => {
        transitionRender();
        if (localizationForm && countryInput && select.value !== root.dataset.country) {
          countryInput.value = select.value;
          localizationForm.requestSubmit();
        }
      });
      document.addEventListener('change', (event) => {
        if (event.target.matches('form[action*="/cart/add"] [name="id"], select[data-option-name], input[data-option-name]')) {
          window.setTimeout(transitionRender, 0);
        }
      });
      render();
    };

    const initializeAll = (scope = document) => {
      scope.querySelectorAll('[data-duty-estimator]').forEach(initialize);
    };

    initializeAll();
    document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
  })();
  } catch(e) { console.error(e); }
})();

})();
